"use strict";

const stagingConfig = {
  NAME: "AAUTI SOCIAL CORE STAGING",
  ENV: "staging",
  SOCIAL_API_URL: "YOUR_SOCIAL_API_URL",
  SOCIAL_TENANT_ID: "YOUR_SOCIAL_TENANT_ID"
};
export default stagingConfig;
//# sourceMappingURL=staging.js.map